
export default function FamilyHealthSection() {
  return (
    <section className="py-10 sm:py-12 md:py-16 bg-gradient-to-br from-amber-50 via-white to-brand-50">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          {/* Left Side - Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-2 sm:gap-3 md:gap-4">
              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl h-36 sm:h-48 md:h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=mother%20and%20young%20child%20aged%203%20years%20taking%20vitamins%20together%20at%20breakfast%20table%2C%20happy%20family%20health%20routine%2C%20bright%20kitchen%20setting%20with%20natural%20morning%20light%2C%20professional%20lifestyle%20photography%20showing%20parental%20care%20and%20child%20wellness%2C%20warm%20atmosphere%2C%20high%20quality%20image&width=400&height=500&seq=fam1&orientation=portrait"
                    alt="Anne ve Çocuk"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl h-28 sm:h-36 md:h-48">
                  <img
                    src="https://readdy.ai/api/search-image?query=teenage%20siblings%20aged%2010%20to%2015%20years%20old%20exercising%20together%20outdoors%2C%20active%20healthy%20lifestyle%2C%20bright%20sunny%20day%20with%20green%20nature%20background%2C%20professional%20photography%20showing%20youth%20fitness%20and%20wellness%2C%20energetic%20atmosphere%2C%20high%20quality%20image&width=400&height=400&seq=fam2&orientation=squarish"
                    alt="Kardeşler"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-2 sm:space-y-3 md:space-y-4 pt-4 sm:pt-6 md:pt-8">
                <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl h-28 sm:h-36 md:h-48">
                  <img
                    src="https://readdy.ai/api/search-image?query=father%20playing%20with%20toddler%20aged%202%20years%20old%20in%20park%2C%20happy%20dad%20and%20baby%20bonding%20moment%2C%20bright%20outdoor%20setting%20with%20green%20grass%2C%20professional%20family%20photography%20showing%20health%20and%20joy%2C%20natural%20sunlight%2C%20warm%20loving%20atmosphere%2C%20high%20quality%20image&width=400&height=400&seq=fam3&orientation=squarish"
                    alt="Baba ve Bebek"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl h-36 sm:h-48 md:h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=complete%20family%20with%20children%20of%20different%20ages%20from%20baby%20to%20teenager%2C%20multi-generational%20family%20portrait%20showing%20health%20and%20happiness%2C%20bright%20natural%20outdoor%20setting%2C%20professional%20family%20photography%20with%20warm%20atmosphere%2C%20everyone%20smiling%2C%20high%20quality%20lifestyle%20image&width=400&height=500&seq=fam4&orientation=portrait"
                    alt="Aile"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
            {/* Floating Stats */}
            <div className="absolute -bottom-4 sm:-bottom-6 left-1/2 transform -translate-x-1/2 bg-white p-3 sm:p-4 md:p-6 rounded-lg sm:rounded-xl shadow-xl sm:shadow-2xl w-[85%] sm:w-72 md:w-80">
              <div className="flex items-center justify-around">
                <div className="text-center">
                  <div className="text-lg sm:text-xl md:text-2xl font-bold text-brand-600">98%</div>
                  <div className="text-[9px] sm:text-[10px] md:text-xs text-gray-600">Memnuniyet</div>
                </div>
                <div className="w-px h-8 sm:h-10 md:h-12 bg-gray-200"></div>
                <div className="text-center">
                  <div className="text-lg sm:text-xl md:text-2xl font-bold text-amber-600">15+</div>
                  <div className="text-[9px] sm:text-[10px] md:text-xs text-gray-600">Yıl Tecrübe</div>
                </div>
                <div className="w-px h-8 sm:h-10 md:h-12 bg-gray-200"></div>
                <div className="text-center">
                  <div className="text-lg sm:text-xl md:text-2xl font-bold text-brand-600">50K+</div>
                  <div className="text-[9px] sm:text-[10px] md:text-xs text-gray-600">Mutlu Aile</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-4 sm:space-y-5 md:space-y-6 lg:pl-8 mt-6 lg:mt-0">
            <div className="inline-block bg-amber-100 text-amber-700 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold">
              <i className="ri-heart-fill mr-1.5 sm:mr-2"></i>
              Aileniz İçin En İyisi
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
              Sağlıklı Aileler İçin Güvenilir Çözümler
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed">
              15 yılı aşkın tecrübemizle, 0-16 yaş arası çocuklarınızdan yetişkin aile bireylerinin tamamına kadar herkesin
              sağlığını düşünerek özel formüller geliştiriyoruz.
            </p>

            <div className="space-y-2.5 sm:space-y-3 md:space-y-4">
              <div className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-white rounded-lg sm:rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-brand-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-microscope-line text-xl sm:text-2xl text-brand-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm sm:text-base mb-0.5 sm:mb-1">
                    Bilimsel Araştırma
                  </h4>
                  <p className="text-xs sm:text-sm text-gray-600">
                    Her ürünümüz kapsamlı klinik araştırmalar ve testlerle desteklenir
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-white rounded-lg sm:rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-xl sm:text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm sm:text-base mb-0.5 sm:mb-1">
                    %100 Doğal İçerik
                  </h4>
                  <p className="text-xs sm:text-sm text-gray-600">
                    Yapay katkı maddesi, koruyucu ve renklendirici içermez
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-white rounded-lg sm:rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-brand-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-xl sm:text-2xl text-brand-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm sm:text-base mb-0.5 sm:mb-1">
                    Güvenlik Garantisi
                  </h4>
                  <p className="text-xs sm:text-sm text-gray-600">
                    Pediatrist ve diyetisyen onaylı, çocuklar için tamamen güvenli
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-2.5 sm:gap-4 pt-2 sm:pt-4">
              <button className="bg-brand-600 text-white px-5 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-brand-700 transition-all shadow-lg cursor-pointer whitespace-nowrap text-xs sm:text-sm">
                Tüm Ürünleri İncele
              </button>
              <button className="bg-white text-gray-900 px-5 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-gray-50 transition-all border-2 border-gray-200 cursor-pointer whitespace-nowrap text-xs sm:text-sm">
                <i className="ri-play-circle-line mr-1.5 sm:mr-2"></i>
                Hikayemizi İzle
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
